import React from "react";
import { useNavigate } from "react-router-dom";
import StatusLayout from "./StatusLayout";

const TentativeNonConfirmation = () => {
  const navigate = useNavigate();

  return (
    <StatusLayout
      title="Data Mismatch"
      description="Some information does not match government records. Please Edit the Case and Re-Submit."
    >
      <div className="status-section">
        <h3>Next Steps</h3>
        <ul className="status-steps">
          <li className="status-step">
            <div className="status-step-body">
              <p>Review and correct the employee's information.</p>
              <div className="status-actions">
                <button
                  type="button"
                  className="status-primary"
                  onClick={() => navigate("/case/confirm-details")}
                >
                  Edit Case
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </StatusLayout>
  );
};

export default TentativeNonConfirmation;
